import { render } from "./wpsr.vue?vue&type=template&id=f66f1650&scoped=true"
import script from "./wpsr.vue?vue&type=script&lang=js"
export * from "./wpsr.vue?vue&type=script&lang=js"

import "./wpsr.vue?vue&type=style&index=0&id=f66f1650&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f66f1650"]])

export default __exports__